import { FC } from 'react';
import {
    NotificationModel,
    notificationsAPI,
    NotificationsModel,
} from '../../../APIs/notificationsAPI';
import { columnDefiner, Table } from '../../atomic/table';
import { Link, useNavigate } from 'react-router';
import { IconButton } from '../../atomic/buttons';
import { reformat } from '../../../utils/DateUtils';
import { LimitedMutator, useGet } from '../../../hooks/useApi';
import { useAuth } from '../../../contexts/AuthContext';
import { tenantApi } from '../../../APIs/tenants';
import { TenantModel } from '../../../models/TenantModel';

interface NotificationData extends NotificationModel {
    trClass: string;
}
const definer = columnDefiner<NotificationData>();

type NotificationListProp = {
    notifications: NotificationsModel;
    mutate: LimitedMutator<{
        pagination?: any;
        data: NotificationsModel;
    }>;
};
export const NotificationList: FC<NotificationListProp> = ({
    notifications,
    mutate,
}) => {
    const navigate = useNavigate();
    const { isSuperAdmin } = useAuth();

    const { data: tenants } = useGet(
        isSuperAdmin() ? tenantApi.get.getTenantsForSuperAdmin : null
    );

    const onDelete = (notificationId: string) => {
        notificationsAPI.admin.delete(notificationId);
        mutate();
    };
    const authMode = isSuperAdmin() ? 'superadmin' : 'admin';

    const options = {
        mutate,
        onDelete,
        navigate,
        authMode,
        tenants: tenants?.data,
        isSuperAdmin,
    };

    const defaultColumns = [
        definer.accessor('notificationType', {
            header: 'タイプ',
            cell: (d: any) => {
                const { notificationType } = d.row.original;
                return <>{notificationType}</>;
            },
        }),
        {
            header: 'テナント名',
            cell: (d: any) => {
                const { tenantId } = d.row.original;
                const { tenants, isSuperAdmin } = d.table.options;
                const tenantName = isSuperAdmin()
                    ? () => {
                          if (tenantId && tenants) {
                              const tenant = tenants.find(
                                  (tenant: TenantModel) =>
                                      tenantId === tenant.tenantId
                              );
                              if (tenant) return tenant.name;
                          }

                          return '';
                      }
                    : () => {
                          return '';
                      };

                return <>{tenantName()}</>;
            },
        },
        {
            header: 'タイトル',
            cell: (d: any) => {
                const { title, notificationId } = d.row.original;
                const { navigate, authMode } = d.table.options;
                return (
                    <>
                        <Link
                            to={`#`}
                            onClick={() => {
                                navigate(
                                    `/app/${authMode}/notification/edit/${notificationId}`
                                );
                            }}
                        >
                            {title}
                        </Link>
                    </>
                );
            },
        },
        {
            header: '作成日時',
            cell: (d: any) => {
                const { createdAt } = d.row.original;
                return <>{reformat(createdAt, 'yyyy/MM/dd HH:mm')}</>;
            },
        },
        {
            header: '表示',
            cell: (d: any) => {
                const { isVisible, isVisibleLogin, tenantId } = d.row.original;
                const visible = () => {
                    if (!isVisible) {
                        return '非表示';
                    }
                    if (isVisibleLogin && !tenantId) {
                        return 'ログイン画面';
                    }
                    return 'ホーム画面';
                };

                return <>{visible()}</>;
            },
        },
        {
            header: '操作',
            cell: (d: any) => {
                const { notificationId } = d.row.original;
                const { navigate, onDelete, authMode } = d.table.options;
                const { isVisible } = d.row.original;
                return (
                    <>
                        <IconButton
                            icon="fa-solid fa-edit"
                            onClick={() => {
                                navigate(
                                    `/app/${authMode}/notification/edit/${notificationId}`
                                );
                            }}
                            title={'編集'}
                        />
                        {!isVisible && (
                            <IconButton
                                icon="fa-solid fa-trash"
                                onClick={() => {
                                    onDelete(notificationId);
                                }}
                                title={'削除'}
                            />
                        )}
                    </>
                );
            },
        },
    ];

    const columns = isSuperAdmin()
        ? defaultColumns
        : defaultColumns.filter(
              (c) =>
                  c.header !== 'テナント名' && c.header !== 'ログイン時に表示'
          );

    return (
        <>
            <Table
                className="notifications-table"
                data={notifications}
                columns={columns}
                options={options}
            />
        </>
    );
};
